import { BodyText } from '@postscript/components';
import { MessageDirections } from 'components/messagePreview/constants';
import { MessageDirection } from 'components/messagePreview/types';
import Linkify from 'linkify-react';
import styled from 'styled-components';

interface StyledContentPreviewProps {
  direction?: MessageDirection;
}

const StyledContentPreview = styled(BodyText)<StyledContentPreviewProps>`
  background: var(--color-message-bubble-outbound);
  border-radius: ${({ direction }) =>
    `var(--border-radius-small) var(--border-radius-small) ${
      direction === MessageDirections.OUTGOING
        ? '0'
        : 'var(--border-radius-small)'
    } ${
      direction === MessageDirections.INCOMING
        ? '0'
        : 'var(--border-radius-small)'
    }`};
  color: var(--text-color-dim);
  margin-bottom: 0;
  padding: var(--spacing-2) var(--spacing-3);
  white-space: pre-line;
  word-break: break-word;
  word-wrap: break-word;

  & + & {
    margin-top: calc(var(--spacing-1) / 2);
  }
`;

interface ContentPreviewProps {
  contentPreview: string;
  direction?: MessageDirection;
}

const ContentPreview = ({ contentPreview, direction }: ContentPreviewProps) => {
  return (
    <StyledContentPreview forwardedAs="p" size="x-small" direction={direction}>
      <Linkify options={{ target: '_blank' }}>{contentPreview}</Linkify>
    </StyledContentPreview>
  );
};

export default ContentPreview;
